import { OptionType, ScheduleType } from 'types/schedule'
import { Action, Dispatch } from 'redux'
import { confirmSchedulesAction } from 'reducks/schedule/actions'

const confirmSchedules = (
  dailySchedules: ScheduleType[],
  preorderSchedules: ScheduleType[],
  isTypeDaily: boolean,
  isTypePreorder: boolean,
  options: OptionType[]
) => {
  return async (dispatch: Dispatch<Action>) => {
    // 各schedulesにoptionsを追加
    const nextDailySchedules = dailySchedules.map((schedule) => {
      schedule.options = options
      return schedule
    })
    const nextPreorderSchedules = preorderSchedules.map((schedule) => {
      schedule.options = options
      return schedule
    })
    // 有効なtypeに応じてschedulesを追加
    const schedules: ScheduleType[] = []
    if (isTypeDaily) {
      schedules.push(...nextDailySchedules)
    }
    if (isTypePreorder) {
      schedules.push(...nextPreorderSchedules)
    }
    dispatch(confirmSchedulesAction(schedules))
  }
}

export default confirmSchedules
